
import { connect } from 'react-redux'
import ViewSingleRole from 'modules/ViewSingleRole/index'
import selector from 'modules/Roles/selectors'
import {getSingleRoleDetails, SaveRole, ApplyRole,jobSharingEmail, getSingleEligibleRoleDetails,getTPOApprovalRequest,getViewedRoleUpdate} from 'modules/ViewRole/actions'
import { getRoleFloatDetails,getEligibleDetails,updateRoleFloatDetails ,getCompTypeList,getStudentRuleSet} from '../../Roles/actions'
import selector2 from 'modules/Onboarding/selectors'
import {getFunctionsList,getListOfSkills,   getListOfCountries,
    getListOfState,
    getListOfCity,
    searchAPI,
    updateCvDetails,
    deleteEducation
    } from 'modules/Onboarding/actions'
import { getStudentData,updateStudentData,updateStudent,getStudentResumeData,getPendingData} from 'modules/Resume/actions'
import { getNewRoleMetrics } from 'modules/Applied_Roles/actions'

import { studentOptedStatus } from '../../Dashboard/actions'
import selectors3 from '../../Dashboard/selectors'
import { getCities } from 'modules/Resume/actions'
import { geStudentQuestionaireResult } from '../../Roles/Questionnaire/actions'
const mapStateToProps = state => ({
    viewRoleDetails: selector.getSingleRoleDetails(state),
    collegeData: selector2.getCampuDetails(state),
    functionsList: selector2.getFunctionsList(state),
    studentDetails: selector2.getStudentResumeData(state),
    studentData: selector2.getStudentDetails(state),
    stateList: selector2.getStateList(state),
    studentFormData: selector2.getStudentEditData(state),
    optoutStatus: selectors3.getOptOutStatus(state),
    countryList: selector2.getCountryList(state),
})

const mapDispatchToProps = {
     getSingleRoleDetails,
    SaveRole,
    ApplyRole,
    jobSharingEmail,
    getRoleFloatDetails,
    getEligibleDetails,
    getFunctionsList,
    updateStudentData,
    updateRoleFloatDetails,
    getStudentData,
    getListOfSkills,
    getSingleEligibleRoleDetails,
    getCompTypeList,
    getStudentRuleSet,
    getTPOApprovalRequest,
    getViewedRoleUpdate,
    getNewRoleMetrics,
    updateStudent,
    getListOfCountries,
    getListOfState,
    getListOfCity,
    searchAPI,
    updateCvDetails,
    studentOptedStatus,
    getCities,
    geStudentQuestionaireResult,
    deleteEducation,
    getStudentResumeData,
    getPendingData
    
    
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewSingleRole)
